'use client';
import { DirectionsMap } from './components';

interface GetDirectionsProps {
  eventAddress: string;
  location: [number, number] | null;
}

export default function GetDirections({
  eventAddress,
  location,
}: GetDirectionsProps): React.ReactNode {
  if (!location || location.length < 2) return <></>;

  return <DirectionsMap location={location} eventAddress={eventAddress} />;
}
